// ************************************************************************************************
// pathname: /v1/job-operation/job-template
// ************************************************************************************************
import { ApiQueryParams } from '@type/api/apiUtilityFn';
import { useSwrApi } from '@hooks/useSwrApi';
import { buildSearchParams } from '@utils/data-fetching';

/** Props */
interface UseSwrJobTemplateProps {
  locale: Locale,
  serverData?: ApiSchema<'JobModel2'>,
  params?: ApiQueryParams<'/v1/job-operation/job-template', 'get'>,
  successCallback?: (data?: ApiSchema<'JobModel2'>) => void,
}

/**
 * @description SWR: fetch job template.
 * - `locale` - the current locale
 * - `serverData` - server data
 * - `successCallback` - success callback
 * - `jobId` - the job id
 * - `jobSlug` - the job slug
 * - `plainText` - if true, the response will be plain text (strip HTML tags)
 */
export const useSwrJobTemplate = (props: UseSwrJobTemplateProps) => {
  const {
    locale,
    serverData,
    successCallback,
    params,
  } = props;

  return useSwrApi<ApiSchema<'JobModel2'>>({
    url: '/v1/job-operation/job-template',
    urlParams: buildSearchParams(params),
    locale,
    serverSideData: serverData,
    apiOptions: {
      revalidateOnFocus: false,
      revalidateOnMount: false,
      keepPreviousData: true,
      // don't revalidate if we don't have a job slug, just use the server data
      revalidateIfStale: !!params?.jobSlug,
      onSuccess: (response) => {
        if (successCallback) successCallback(response);
      },
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });
};
